import {BaseSingleInputComponent, BaseSingleInputComponentController} from "../baseSingleInput.component";

export class DateInputComponent extends BaseSingleInputComponent {
    protected getController(): typeof BaseSingleInputComponentController {
        return DateInputComponentController;
    }

    protected getTemplateUrl(): string {
        return './modules/quoteWizard/components/singleInputComponents/date/dateInput.view.html';
    }

    protected getBindings(): any {
        return {
        };
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface IDateInputComponentController {
    isDatePopupOpened: boolean;

    datepickerOptions: any;

    goNext(): void;

    goBack(): void;

    openDatePopup(): void;

    isValidDate(): boolean;

}

// tslint:disable-next-line:max-classes-per-file
export class DateInputComponentController extends BaseSingleInputComponentController implements IDateInputComponentController {
    public isDatePopupOpened: boolean = false;

    public acceptableFormats: string[] = [
        'M!/d!/yyyy',
        'd!-MMMM-yyyy',
        'yyyy/M!/d!',
        'd!.M!.yyyy',
        'shortDate',
        'yyyy-M!-d!'
    ];

    public datepickerOptions: any = {
        showWeeks: false
    };

    public openDatePopup(): void {
        this.isDatePopupOpened = true;
    }

    protected activate() {
        super.activate();
        if (this.modelBinding && moment.isDate(this.modelBinding)) {
            this.modelBinding = moment(this.modelBinding).toDate();
        }
    }

    public isValidDate(): boolean {
        return !!this.modelBinding && moment(this.modelBinding).isValid() && moment.isDate(this.modelBinding);
    }
}
